import {useCallback, useEffect, useMemo, useState} from "react"
import {useDispatch} from "react-redux"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"
import {userAPI} from "../../api/userAPI"

export const useUserResendTFAAPI = () => {
    const dispatch = useDispatch()
    const [status, setStatus] = useState(APIStatus.Initial)
    const [secondsLeft, setSecondsLeft] = useState(0)

    useEffect(() => {
        if (!secondsLeft) {
            return
        }
        const timeout = setTimeout(() => setSecondsLeft((timeLeft) => timeLeft - 1), 1000)
        return () => {
            clearTimeout(timeout)
        }
    }, [secondsLeft])

    const resendTFA = useCallback(
        (email) => {
            setStatus(APIStatus.Loading)
            setSecondsLeft(0)
            dispatch(
                userAPI.resendTFA({
                    payload: {
                        email,
                    },
                    onSuccess: () => {
                        setStatus(APIStatus.Success)
                        setSecondsLeft(60)
                    },
                    onError: (err) => {
                        setStatus(APIStatus.Failure)
                        if (err?.response?.status === 429) {
                            setSecondsLeft(err?.retryAfter ?? 60)
                        }
                    },
                })
            )
        },
        [dispatch]
    )

    return useMemo(
        () => ({
            resendTFA,
            status,
            timeLeft: secondsLeft,
        }),
        [resendTFA, status, secondsLeft]
    )
}
